module.exports = __webpack_public_path__ + "img/empty-inbox.308ca32f.png";